"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVLocation_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var IVLocation_Factory = /** @class */ (function () {
    function IVLocation_Factory() {
    }
    IVLocation_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    IVLocation_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return IVLocation_Factory;
}());
exports.IVLocation_Factory = IVLocation_Factory;
